import ConditionalToolTip from "components/design/conditionalToolTip";
import { PadlockIcon } from "./PadlockIcon";

export const Padlock = ({ showTooltip = true }: { showTooltip?: Boolean }) => (
  <ConditionalToolTip condition={showTooltip && "You have read-only access"}>
    <span>
      <PadlockIcon />
    </span>
  </ConditionalToolTip>
);
